// /**
//  * Copyright © Studioworx. All rights reserved.
//  */

//
//  Mega Menu
//  ---------------------------------------------

(function($) {
    var body = document.getElementsByTagName('body')[0];

    if ( !("ontouchstart" in body) ) var hasTouch = false;
    else hasTouch = true;

    if ( hasTouch ) {
        var $navItems = $('.menu-item-has-children');
        $('[data-toggle="mega-menu"]').click(function(event) {
            event.preventDefault();
            var isTouched = $(this).parent().hasClass('touched');
            $navItems.removeClass('touched');
            if ( !isTouched ) $(this).parent().addClass('touched');
        });
        body.className += (body.className?" ":"") + "has-touch";
    } else {
        $('.menu-item-has-children').hover(function(event) {
            $(this).addClass('hover');
            $('body').addClass('nav-hover');
        }, function(event) {
            $(this).removeClass('hover');
            $('body').removeClass('nav-hover');
        });
        body.className += (body.className?" ":"") + "no-touch";
    }
})(jQuery);

//
//  Swiper
//  ---------------------------------------------

import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper';

(function($) {
    const partner_network_swiper = new Swiper('.partner-network .swiper', {
        modules: [Autoplay],
        autoplay: true,
        loop: true,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            },
            1400: {
                slidesPerView: 6,
            },
        },
    });

    const featured_articles_swiper = new Swiper('#featured-articles .swiper', {
        modules: [Pagination, Autoplay],
        autoplay: true,
        loop: true,
        speed: 500,
        pagination: {
            el: '#featured-articles .articles',
            clickable: true,
            renderBullet: function (index, className) {
                var title = $('#featured-articles .swiper .swiper-slide:nth-of-type(' + (index + 1) + ') [data-title]').html();
                var tags = $('#featured-articles .swiper .swiper-slide:nth-of-type(' + (index + 1) + ') [data-tags]').html();
                return '<div class="article ' + className + '"><div class="tags">' + tags + '</div><h2>' + title + "</h2></div>";
          }
        },
    });
})(jQuery);

//
//  End
//  ---------------------------------------------
